import { ApiTokenSchema } from '@retro-ui/prisma';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/api-token';

const SanitizedApiToken = ApiTokenSchema.omit({ encryptedToken: true });
export const apiTokenContract = c.router(
  {
    fetchTokens: {
      method: 'GET',
      path: '',
      responses: {
        200: z.array(SanitizedApiToken),
      },
    },
    createToken: {
      method: 'POST',
      path: '',
      body: SanitizedApiToken.pick({ name: true }),
      responses: {
        201: SanitizedApiToken.extend({
          token: z.string(),
        }),
      },
    },
    removeToken: {
      method: 'DELETE',
      path: '',
      body: SanitizedApiToken.pick({ id: true }),
      responses: {
        200: SanitizedApiToken.pick({ id: true }),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
